import React, { useEffect, useState } from "react";
import { isDesktop, isTablet } from "react-device-detect";
import { AlertNoMobile } from "./pages/common/AlertNoMobile";
import { PrincipalRouter } from "./routers";
import { logos } from "./assets";
// import {  } from "react-device-detect";

function App() {
	const [orientation, setOrientation] = useState(window.orientation);

	useEffect(() => {
		const handleOrientationChange = () => {
			setOrientation(window.orientation);
		};

		window.addEventListener("orientationchange", handleOrientationChange);

		return () => {
			window.removeEventListener("orientationchange", handleOrientationChange);
		};
	}, []);

	const isPortrait = orientation === 0 || orientation === 180;

	if (isTablet || isDesktop) {
		if (isPortrait) {
			return (
				<div className="fixed top-0 w-full h-full bg-1B1464">
					<div className="w-full h-full flex flex-col justify-center items-center">
						<img className="mb-4" src={logos.inmersysLogin} alt="" />
						<p className="text-white font-bold text-xl text-center py-4 w-[320px]">
							Esta app solo esta disponible en Landscape. por favor rota tu dispositivo.
						</p>
					</div>
				</div>
			);
		}
		return <PrincipalRouter />;
	} else {
		return <AlertNoMobile />;
	}
}

export default App;
